// @ts-nocheck — TODO: tipizzare quando si tocca
// ====== Scadenze ======
function renderScadenze() {
  if (!isAdmin()) return;
  if (!$('#tbodyScadenze')) return; // vista "scadenze" lazy non ancora montata
  wireScadenzeView();
  const tbody = $('#tbodyScadenze');
  const filter = $('#filterScadenzaPeriodo').value;
  const cplFilter = $('#filterScadenzaCPL').value;
  const tipoFilter = $('#filterScadenzaTipo').value;
  let list = collectScadenze();

  // Popola opzioni dinamiche per CPL e Tipo (raccolte dai dati reali)
  const cpls = [...new Set(list.map((s) => s.cpl).filter(Boolean))].sort();
  const tipi = [...new Set(list.map((s) => s.tipo).filter(Boolean))].sort();
  fillSelect($('#filterScadenzaCPL'), cpls, 'Tutti i CPL');
  fillSelect($('#filterScadenzaTipo'), tipi, 'Tutti i tipi');

  // Filtro periodo
  list = list.filter((s) => {
    if (filter === 'all') return true;
    if (filter === 'aperte') return !s.completata;
    if (filter === 'scadute') return s.giorni !== null && s.giorni < 0 && !s.completata;
    const lim = parseInt(filter, 10);
    if (!isNaN(lim))
      return s.giorni !== null && s.giorni <= lim && s.giorni >= -30 && !s.completata;
    return true;
  });
  // Filtri aggiuntivi
  if (cplFilter) list = list.filter((s) => s.cpl === cplFilter);
  if (tipoFilter) list = list.filter((s) => s.tipo === tipoFilter);

  list.sort((a, b) => (a.giorni ?? 99999) - (b.giorni ?? 99999));

  tbody.innerHTML = list.length
    ? list
        .map((s) => {
          const rowCls = s.completata
            ? ''
            : s.giorni !== null && s.giorni < 0
              ? 'expired'
              : s.giorni !== null && s.giorni <= 30
                ? 'expiring'
                : '';
          const snoozeBtn =
            !s.completata && !s.virtual && s.id
              ? `<span class="snooze-trigger-wrap"><button class="btn btn-sm" data-snooze data-cliente="${escapeHtml(s.cliente)}" data-scad="${escapeHtml(s.id)}" title="Rimanda scadenza">⏰ Snooze</button></span>`
              : '';
          return `
      <tr class="${rowCls}" data-cliente="${escapeHtml(s.cliente)}">
        <td><strong>${escapeHtml(s.cliente)}</strong></td>
        <td>${escapeHtml(s.titolo)}${s.virtual ? ' <span class="muted">(da contratto)</span>' : ''}</td>
        <td>${escapeHtml(s.tipo || '—')}</td>
        <td>${escapeHtml(fmtDate(s.data))}</td>
        <td>${s.completata ? '<span class="deadline-pill dl-done">Completata</span>' : `<span class="deadline-pill ${deadlinePillClass(s.giorni)}">${formatGiorni(s.giorni)}</span>`}</td>
        <td style="display:flex;gap:6px;flex-wrap:wrap;">
          ${snoozeBtn}
          <button class="btn btn-sm" data-open-row>Apri cliente</button>
        </td>
      </tr>`;
        })
        .join('')
    : '<tr><td colspan="6" style="text-align:center;padding:30px;color:var(--text-muted)">Nessuna scadenza in questo periodo.</td></tr>';

  // Click sulla riga → apre il cliente, ma ignoriamo i click sui pulsanti snooze
  tbody.querySelectorAll('tr[data-cliente]').forEach((tr) => {
    tr.addEventListener('click', (e) => {
      if (e.target.closest('[data-snooze]')) return;
      openModal(tr.dataset.cliente, 'scadenze');
    });
  });
  // Bind snooze
  tbody.querySelectorAll('[data-snooze]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      if (typeof attachSnoozePopover === 'function') {
        attachSnoozePopover(btn, btn.dataset.cliente, btn.dataset.scad);
      }
    });
  });
}

// Event listeners filtri — wiring idempotente (la vista "scadenze" è lazy)
let _scadenzeWired = false;
function wireScadenzeView() {
  if (_scadenzeWired) return;
  if (!document.getElementById('tbodyScadenze')) return; // vista non ancora montata
  ['filterScadenzaPeriodo', 'filterScadenzaCPL', 'filterScadenzaTipo'].forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.addEventListener('change', renderScadenze);
  });
  _scadenzeWired = true;
}
wireScadenzeView(); // no-op finché la vista lazy non è montata

globalThis.renderScadenze = renderScadenze;
export {};
